import React from "react";
import "./Footer.scss";

const Footer = ({ children }) => {
  return <div className="footer">{children}</div>;
};

export default Footer;
